import { FC, useCallback, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { IInvoicePosition } from "../../InvoicePage";
import InvoicePositionsItem from "./components/InvoicePositionsItem";
import producersController from "../../../../Api/producersController";

interface InvoicePositionsFormProps {
    invoicePositions: IInvoicePosition[];
    setInvoicePositions: (positions: IInvoicePosition[]) => void;
}

const InvoicePositionsForm: FC<InvoicePositionsFormProps> = ({
    invoicePositions,
    setInvoicePositions,
}) => {
    const [producersData, setProducersData] = useState<string[] | null>(null)

    const handleAdd = () => {
        setInvoicePositions([
            ...invoicePositions,
            {
                name: "",
                description: "",
                quantity: 1,
                grossPrice: 0,
                vat: 23,
                producer: ""
            },
        ]);
    };

    const handleChange = (index: number, field: keyof IInvoicePosition, value: any) => {
        const updated = invoicePositions.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        setInvoicePositions(updated);
    };

    // Oblicz sumę zamówienia
    const total = invoicePositions.reduce(
        (sum, item) => sum + Number(item.grossPrice) * Number(item.quantity),
        0
    );


    const getProducersData = useCallback(async () => {
        const res = await producersController.getAllProducers()
        if (!res.producers) return
        const producersNames = res.producers.map(producer => producer.name)
        const allProducers = [...producersNames, 'AGA', 'SAMAR']
        allProducers.sort()
        allProducers.push('Inny')
        setProducersData(allProducers)
    }, [])


    useEffect(() => {
        getProducersData()
    }, [getProducersData])


    return (
        <Box sx={{ width: "100%", maxWidth: "1370px", mx: "auto", mt: 4, mb: 4 }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    background: "#f7f7f7",
                    borderRadius: 2,
                    p: 2,
                    boxShadow: 5,
                }}
            >
                {invoicePositions.map((item, idx) => (
                    <InvoicePositionsItem
                        producers={producersData}
                        key={idx.toString()}
                        index={idx}
                        position={item}
                        onChange={handleChange}
                        onDelete={index =>
                            setInvoicePositions(invoicePositions.filter((_, i) => i !== index))
                        }
                    />
                ))}
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    m: 4,
                    mt: 2,
                }}
            >
                <Button
                    variant="contained"
                    color="success"
                    onClick={handleAdd}
                    sx={{ fontWeight: 700, letterSpacing: 1, boxShadow: 2 }}
                >
                    Dodaj pozycję
                </Button>
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 18,
                        letterSpacing: 1,
                        background: "#e8f5e9",
                        color: "#388e3c",
                        px: 3,
                        py: 1,
                        borderRadius: 2,
                        boxShadow: "0 2px 8px 0 rgba(56,142,60,0.08)",
                    }}
                >
                    Suma zamówienia: {total.toFixed(2)} PLN
                </Typography>
            </Box>
        </Box>
    );
};

export default InvoicePositionsForm;